import { NgModule }      from '@angular/core';
import { UserLoginService } from '../user.login.service';


@NgModule({
  imports:      [ ],
  declarations: [ ],
  providers: [ 
    UserLoginService 
  ],
  exports:      [ ],
})

export class UserApiModule {
}


// WEBPACK FOOTER //
// ./src/angular-engine/engine/service/user/module/user.api.module.ts